import React from 'react'
import { Helmet } from 'react-helmet'

export default function NotFound() {
    return (
        <div>
            <Helmet>
                <title>Not Found Page</title>
            </Helmet>
            NotFound
        </div>
    )
}
